import { NotificationT } from 'lib-knowledge-remote-types/general.types';
import { ReactNode, useCallback, useContext } from 'react';

import {
  NotificationContext,
  NotificationContextValue,
} from '../contexts/notification';

type NotifyErrorInput = {
  text: ReactNode;
} & Partial<NotificationT>;

type NotifySuccessInput = {
  title: string;
  text: ReactNode;
} & Partial<NotificationT>;

type UseNotificationReturn = {
  successNotify: (input: NotifySuccessInput) => void;
  errorNotify: (input: NotifyErrorInput) => void;
  notify: NotificationContextValue;
};

export function useNotification(): UseNotificationReturn {
  const notify = useContext(NotificationContext);

  const errorNotify = useCallback(
    ({ title = 'Something went wrong', text, ...opts }: NotifyErrorInput) => {
      notify({
        icon: 'exclamation-circle-filled',
        time: 2000,
        status: 'danger',
        reason: null,
        waitingTime: null,
        startTime: null,
        leftAction: null,
        ...opts,
        title,
        text,
      });
    },
    [notify],
  );

  const successNotify = useCallback(
    ({ title, text, ...opts }: NotifySuccessInput) => {
      notify({
        icon: 'check-circle-filled',
        time: 3000,
        status: 'success',
        reason: null,
        waitingTime: null,
        startTime: null,
        leftAction: null,
        ...opts,
        title,
        text,
      });
    },
    [notify],
  );

  return {
    errorNotify,
    successNotify,
    notify,
  };
}
